import { render, staticRenderFns } from "./ClipboardCopy.vue?vue&type=template&id=444b0528&scoped=true&"
import script from "./ClipboardCopy.vue?vue&type=script&lang=js&"
export * from "./ClipboardCopy.vue?vue&type=script&lang=js&"
import style0 from "./ClipboardCopy.vue?vue&type=style&index=0&id=444b0528&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b0528",
  null
  
)

export default component.exports